import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '../fragments';

export default gql`
  mutation createWarrantyNote($input: WarrantyNoteCreateInput!) {
    createWarrantyNote(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warrantyNote {
        id
        message
        warrantyId
        adminUserId
        partnerUserId
        showPartner
        showUser
        adminUser {
          id
          firstName
          lastName
        }
        partnerUser {
          id
          firstName
          lastName
          partnerLocation {
            id
            name
          }
          partnerOrganization {
            id
            name
          }
        }
        createdAt
        updatedAt
      }
    }
  }
  ${ErrorMessageInfo}
`;
